<!--
 * @Author: wzc
 * @Date: 2021-12-15 10:39:41
 * @LastEditors: wzc
 * @LastEditTime: 2021-12-15 16:48:31
 * 赛程列表 横向切换日历， swiper 实现
-->
<template>
  <div class="SWIPER_SCHEDULE_DATE">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide
        v-for="(groupItem, groupIndex) in dateList"
        :key="groupIndex"
      >
        <div
          class="date_item"
          v-for="item in groupItem.dayArr"
          :key="item.date"
          :class="item.isAct ? 'act' : ''"
          @click="clickItem(item)"
        >
          <span class="date_item_main">
            <span class="itemMain_matchName">
              <span class="floor1" v-text="item.scheduleName"></span>
              <span
                v-if="item.unitType && item.unitType.indexOf('H') === 0"
                class="floor2"
                v-text="`${item.competitor1Name} VS ${item.competitor2Name}`"
              ></span>
            </span>
            <span
              class="itemMain_matchDate"
              v-text="`${item.formatDate} ${item.formatTime}`"
            ></span>
          </span>
        </div>
      </swiper-slide>
    </swiper>
    <div
      :class="!isShowPrevBtn ? 'notClick' : ''"
      class="swiper-button-prev"
      @click="clickPrev()"
    >
      <i class="el-icon el-icon-arrow-left"></i>
    </div>
    <div
      :class="!isShowNextBtn ? 'notClick' : ''"
      class="swiper-button-next"
      @click="clickNext()"
    >
      <i class="el-icon el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
  name: 'SWIPER_SCHEDULE_DATE',
  components: { Swiper, SwiperSlide },
  directives: {
    swiper: directive,
  },
  props: {
    datas: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     dayArr: [
        //       {
        //         matchTime: '09:20',
        //         matchName: '羽毛球·男子双打1/4决赛第3场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------QNL-03------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打1/4决赛第3场',
        //         formatDate: '07月30日',
        //         formatTime: '09:20',
        //         medalist: [],
        //         homeName: 'Feng ZM/Wei YG',
        //         awayName: 'Du JY/Zhao HB',
        //         homeScore: '1',
        //         awayScore: '2',
        //         homeLogo: '',
        //         awayLogo: 'COM',
        //         isAct: true,
        //       },
        //       {
        //         matchTime: '09:20',
        //         matchName: '羽毛球·男子双打1/4决赛第4场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------QNL-04------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打1/4决赛第4场',
        //         formatDate: '07月30日',
        //         formatTime: '09:20',
        //         medalist: [],
        //         homeName: 'Zheng H/Ma YC',
        //         awayName: 'Chen MH/Tong YY',
        //         homeScore: '0',
        //         awayScore: '2',
        //         homeLogo: '',
        //         awayLogo: 'CAN',
        //         isAct: false,
        //       },
        //       {
        //         matchTime: '09:20',
        //         matchName: '羽毛球·男子双打1/4决赛第1场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------QNL-01------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打1/4决赛第1场',
        //         formatDate: '07月30日',
        //         formatTime: '09:20',
        //         medalist: [],
        //         homeName: 'Yuan Y/Pu QY',
        //         awayName: 'Yan RT/Yan RY',
        //         homeScore: '2',
        //         awayScore: '0',
        //         homeLogo: '',
        //         awayLogo: 'BOL',
        //         isAct: false,
        //       },
        //       {
        //         matchTime: '09:20',
        //         matchName: '羽毛球·男子双打1/4决赛第2场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------QNL-02------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打1/4决赛第2场',
        //         formatDate: '07月30日',
        //         formatTime: '09:20',
        //         medalist: [],
        //         homeName: 'Hu HW/Zhang ZX',
        //         awayName: 'Li JH/Zhang WY',
        //         homeScore: '2',
        //         awayScore: '1',
        //         homeLogo: '',
        //         awayLogo: 'CAN',
        //         isAct: false,
        //       },
        //       {
        //         matchTime: '09:50',
        //         matchName: '羽毛球·男子双打半决赛第2场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------SNL-02------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打半决赛第2场',
        //         formatDate: '07月30日',
        //         formatTime: '09:50',
        //         medalist: [],
        //         homeName: 'Du JY/Zhao HB',
        //         awayName: 'Chen MH/Tong YY',
        //         homeScore: '0',
        //         awayScore: '2',
        //         homeLogo: '',
        //         awayLogo: 'CAN',
        //         isAct: false,
        //       },
        //     ],
        //   },
        //   {
        //     dayArr: [
        //       {
        //         matchTime: '09:50',
        //         matchName: '羽毛球·男子双打半决赛第1场',
        //         isChina: false,
        //         isGold: false,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------SNL-01------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打半决赛第1场',
        //         formatDate: '07月30日',
        //         formatTime: '09:50',
        //         medalist: [],
        //         homeName: 'Yuan Y/Pu QY',
        //         awayName: 'Hu HW/Zhang ZX',
        //         homeScore: '2',
        //         awayScore: '1',
        //         homeLogo: '',
        //         awayLogo: 'BUR',
        //         isAct: false,
        //       },
        //       {
        //         matchTime: '14:30',
        //         matchName: '羽毛球·男子双打金牌赛',
        //         isChina: false,
        //         isGold: true,
        //         type: 'combat',
        //         matchId: 'BDMMDOUBLES-----------FNL-01------',
        //         venueName: '双流体育中心体育馆',
        //         matchStatus: 'FINISHED',
        //         sportsId: 'BDM',
        //         sportsName: '羽毛球',
        //         eventId: 'BDMMDOUBLES-----------------------',
        //         scheduleName: '男子双打金牌赛',
        //         formatDate: '07月30日',
        //         formatTime: '14:30',
        //         medalist: [],
        //         homeName: 'Yuan Y/Pu QY',
        //         awayName: 'Chen MH/Tong YY',
        //         homeScore: '0',
        //         awayScore: '2',
        //         homeLogo: '',
        //         awayLogo: 'CAN',
        //         isAct: false,
        //       },
        //     ],
        //   },
        // ]
      },
    },
    currMatch: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isShowPrevBtn: false,
      isShowNextBtn: false,
      initialIndex: 0,
    }
  },
  created() {
    console.debug('swiper:', this.currMatch, this.dateList)
    // this.dateList.forEach((groupItem, groupIndex) => {
    //   groupItem.dayArr.forEach((item) => {
    //     if (this.currMatch == item.matchId) {
    //       item.isAct = true
    //       this.initialIndex = groupIndex
    //     } else {
    //       item.isAct = false
    //     }
    //   })
    // })
    // console.debug(this.dateList);
  },
  mounted() {
    this.swiper.slideTo(this.initialIndex, 1000, false)
    this.isShowSwiperBtnHandler(this.swiper)
    this.swiper.on('slideChange', (swiper) => {
      this.isShowSwiperBtnHandler(swiper)
    })
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    dateList() {
      let datas = JSON.parse(JSON.stringify(this.datas))
      return datas.map((groupItem, groupIndex) => {
        groupItem.dayArr.forEach((item) => {
          if (this.currMatch == item.matchId) {
            item.isAct = true
            this.initialIndex = groupIndex
          } else {
            item.isAct = false
          }
        })
        return groupItem
      })
    },
  },
  methods: {
    clickPrev() {
      if (!this.isShowPrevBtn) return
      this.swiper.slidePrev()
      this.isShowSwiperBtnHandler(this.swiper)
    },
    clickNext() {
      if (!this.isShowNextBtn) return
      this.swiper.slideNext()
      this.isShowSwiperBtnHandler(this.swiper)
    },
    isShowSwiperBtnHandler(swiper) {
      // console.debug(swiper.realIndex);
      if (swiper.realIndex == this.dateList.length - 1) {
        this.isShowNextBtn = false
      } else {
        this.isShowNextBtn = true
      }
      if (swiper.realIndex == 0) {
        this.isShowPrevBtn = false
      } else {
        this.isShowPrevBtn = true
      }
    },
    clickItem(item) {
      // this.currMatchHandle(item.matchId)
      this.$emit('updateCurrMatch', item)
    },
    // arabicNum2chinaNum(arabicNum) {
    //   let chinaNum = "";
    //   switch (arabicNum) {
    //     case 1:
    //       chinaNum = "一";
    //       break;
    //     case 2:
    //       chinaNum = "二";
    //       break;
    //     case 3:
    //       chinaNum = "三";
    //       break;
    //     case 4:
    //       chinaNum = "四";
    //       break;
    //     case 5:
    //       chinaNum = "五";
    //       break;
    //     case 6:
    //       chinaNum = "六";
    //       break;
    //     case 7:
    //       chinaNum = "七";
    //       break;
    //     case 8:
    //       chinaNum = "八";
    //       break;
    //     case 9:
    //       chinaNum = "九";
    //       break;
    //     case 10:
    //       chinaNum = "十";
    //       break;
    //     case 11:
    //       chinaNum = "十一";
    //       break;
    //     case 12:
    //       chinaNum = "十二";
    //       break;
    //     case 13:
    //       chinaNum = "十三";
    //       break;
    //     case 14:
    //       chinaNum = "十四";
    //       break;
    //     case 15:
    //       chinaNum = "十五";
    //       break;
    //     case 16:
    //       chinaNum = "十六";
    //       break;
    //     case 17:
    //       chinaNum = "十七";
    //       break;
    //     case 18:
    //       chinaNum = "十八";
    //       break;
    //     case 19:
    //       chinaNum = "十九";
    //       break;
    //     case 20:
    //       chinaNum = "二十";
    //       break;
    //     case 21:
    //       chinaNum = "二十一";
    //       break;
    //     case 22:
    //       chinaNum = "二十二";
    //       break;
    //     case 23:
    //       chinaNum = "二十三";
    //       break;
    //     default:
    //       break;
    //   }
    //   return chinaNum;
    // },
    currMatchHandle(matchId) {
      let dateList = this.dateList
      dateList.forEach((groupItem) => {
        groupItem.dayArr.forEach((item) => {
          if (matchId == item.matchId) {
            console.debug(item)
            item.isAct = true
            this.$emit('updateCurrMatch', matchId)
          } else {
            item.isAct = false
          }
        })
      })
      this.dateList = dateList
      this.$forceUpdate()
    },
  },
}
</script>

<style lang="scss">
.SWIPER_SCHEDULE_DATE {
  position: relative;
  height: 7.638vw;
  .swiper-container {
    width: 100%;
    height: 7.638vw;
    overflow: hidden;
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 2.083vw;
    height: 7.638vw;
    top: 0;
    margin-top: 0;
    border: 1px solid var(--mixtmt_greyColor0);
    & > i {
      font-size: 1.11vw;
      color: var(--mixtmt_greyColor0);
    }
    &::after {
      content: '';
    }
    &:hover {
      background: linear-gradient(
        180deg,
        var(--mixtmt_mainColor7) 0%,
        var(--mixtmt_mainColor) 100%
      );
      backdrop-filter: blur(2px);
      & > i {
        color: var(--mixtmt_whiteColor);
      }
    }
    &.notClick {
      &:hover {
        cursor: default;
        background: none;
        & > i {
          color: var(--mixtmt_greyColor0);
        }
      }
    }
  }
  .swiper-button-next {
    right: 0;
    border-radius: 0 0.694vw 0.694vw 0;
  }
  .swiper-button-prev {
    left: 0;
    border-radius: 0.694vw 0 0 0.694vw;
  }

  .swiper-slide {
    display: flex;
    display: -webkit-flex;
    padding: 0 2.778vw;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 7.638vw;
  }
  .date_item {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.694vw;
    width: calc(20% - 0.694vw);
    height: 7.638vw;
    border-radius: 0.278vw;
    color: var(--mixtmt_greyColor2);
    border: 1px solid var(--mixtmt_greyColor0);

    .date_item_main {
      position: absolute;
      left: 0;
      top: 50%;
      z-index: 2;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transform: translateY(-50%);
      width: 100%;
      padding: 0 0.347vw;
      .itemMain_matchName {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        text-align: center;
        height: 4.44vw;
        color: var(--mixtmt_greyColor2);
        .floor1 {
          width: 100%;
          font-size: 1.11vw;
          font-weight: bold;
          line-height: 1.38vw;
        }
      }
      .itemMain_matchDate {
        width: 100%;
        font-size: 0.972vw;
        line-height: 1.11vw;
        text-align: center;
        color: var(--mixtmt_greyColor4);
      }
    }
    &.act,
    &:hover {
      cursor: pointer;
      background: linear-gradient(
        135deg,
        var(--mixtmt_mainColor7) 0%,
        var(--mixtmt_mainColor) 100%
      );
      backdrop-filter: blur(2px);
      .date_item_main {
        .itemMain_matchName {
          color: var(--mixtmt_whiteColor);
        }
        .itemMain_matchDate {
          color: var(--mixtmt_whiteColor);
        }
      }
    }
    /* &.noAct {
        .item_week {
          transform: translateX(-20%);
          -webkit-transform: translateX(-20%);
        }
      } */
  }
}
</style>
